<template>
  <div class="index">
          <p>本数据库依据农业部公告第1773号《饲料原料目录》、农业部公告第2045号《饲料添加剂品种目录（2013）》及增补公告、新饲料和新饲料添加剂批准公告以及农业部公告第2625号《饲料添加剂安全使用规范》开发而成，可对饲料原料的名称、特征描述、强制性标识要求和饲料添加剂的名称、适用范围、含量规格、使用限量等进行查询，查询结果仅供参考。饲料原料和饲料添加剂名称、适用范围、含量规格、使用限量等相关信息的确定，请以具体公告为准。</p>
          <h2>一、本数据库更新情况说明</h2>
          <p>本数据库饲料原料目录已更新至农业农村部公告第1028号</p>
          <p>本数据库饲料添加剂品种目录已更新至农业农村部公告第1025号</p>
          <p>本数据库新饲料已更新至农业农村部公告第1025号</p>
          <p>本数据库新饲料添加剂已更新至农业农村部公告第1025号</p>
          <h2>二、饲料原料目录通则</h2>
          <p>1.本目录所称饲料原料，是指来源于动物、植物、微生物或者矿物质，用于加工制作饲料但不属于饲料添加剂的饲用物质（含载体和稀释剂）。饲料生产企业所使用的饲料原料均应属于本目录规定的品种，并符合本目录的要求。</p>
          <p>2.本目录之外的物质用作饲料原料的，应当经过科学评价并由农业农村部公告列入目录后，方可使用。</p>
          <p>3.按照本目录生产、经营或使用的饲料原料，应符合《饲料卫生标准》、《饲料标签》等强制性标准的要求。</p>
          <p>4.本目录第二部分给出了常用饲料原料加工术语的名称、定义及其形成产品的修饰语，第三部分凡涉及到相应术语的，其含义与第二部分的定义一致。</p>
          <p>5.本目录第三部分原料列表给出了原料名称，饲料原料标签中标识的产品名称应与列表中的“原料名称”一致；饲料产品标签中“原料组成”所使用的原料名称也应与列表中的“原料名称”一致。“原料名称”栏内方括号列出的为饲料原料的常用别名，可以与括号前的名称等同使用。“原料名称”栏内圆括号列出的为相关原料不同物质形态，应根据产品实际进行选择。</p>
          <p>6.本目录第三部分中原料编号采用三级编号格式，第一级表示大类编号；第二级代表相同大类下的不同原料来源；第三级表示相同原料来源下的不同产品。第二级和第三级原则上按首个中文字的拼音顺序进行排列。</p>
          <p>7.本目录第三部分中“强制性标识要求”所规定的为质量要求或卫生特征指标，应在原料标签的分析保证值等项目中列出。</p>
          <p>8.本目录第四部分所列单一饲料品种，是根据
			<el-link v-if="base_url" type="primary" :href="base_url+'2350'" target="_blank">《饲料和饲料添加剂管理条例》</el-link>
			<el-link v-if="!base_url" type="primary" :href="`http://law.foodmate.net/show-174039.html`" target="_blank">《饲料和饲料添加剂管理条例》</el-link>
			及
			<el-link v-if="base_url" type="primary" :href="base_url + '3758'" target="_blank">《饲料和饲料添加剂生产许可管理办法》</el-link>
			<el-link v-if="!base_url" type="primary" :href="`http://law.foodmate.net/show-174811.html`" target="_blank">《饲料和饲料添加剂生产许可管理办法》</el-link>
			和
			<el-link v-if="base_url" type="primary" :href="base_url + '8952'" target="_blank">《进口饲料和饲料添加剂登记管理办法》</el-link>
			<el-link v-if="!base_url" type="primary" :href="`http://law.foodmate.net/show-180973.html`" target="_blank">《进口饲料和饲料添加剂登记管理办法》</el-link>
			，应当办理生产许可证和登记证的产品。未取得生产许可证或进口登记证的单一饲料产品不得作为饲料原料生产、经营和使用。
          </p>
          <p>9.本目录第三部分所称发酵饲料，是指以降解饲料原料中大分子物质、消除或减少抗营养因子等有毒有害物质、提高原料饲用价值等为目的，使用《饲料添加剂品种目录》中的微生物菌种（株）或者同时使用酶制剂等，对本目录饲料原料列表中除9（陆生动物产品及其副产品）、10（鱼、其它水生生物及其副产品）外的原料或者原料混合物进行发酵处理所获得的产品。发酵饲料按照单一饲料品种进行管理。</p>
          <p>10.生产或使用涉及转基因动物、植物、微生物的饲料原料，还应当遵守
			<el-link v-if="base_url" type="primary" :href="base_url + '47'" target="_blank">《农业转基因生物安全管理条例》</el-link>
			<el-link v-if="!base_url" type="primary" :href="`http://law.foodmate.net/show-163478.html`" target="_blank">《农业转基因生物安全管理条例》</el-link>
			的有关规定
          </p>
          <p>11.饲料生产企业使用目录中所列原料，应按照保证饲料和养殖动物质量安全的原则和要求，根据饲喂对象和原料特点合理选择和使用。</p>
          <p>12.除目录中有特殊规定外，植物性饲料原料的植物学纯度通常不得低于95%。</p>
          <p>13.对饲料原料进行瘤胃保护处理的，应在原料标签中标明瘤胃保护方法。</p>
          <h2>三、饲料添加剂目录有关事宜公告</h2>
          <p>1.饲料添加剂的生产企业需办理生产许可证和产品批准文号。</p>
          <p>2.生产源于转基因动植物、微生物的饲料添加剂，以及含有转基因产品成分的饲料添加剂，应按照
			<el-link v-if="base_url" type="primary" :href="base_url + '47'" target="_blank">《农业转基因生物安全管理条例》</el-link>
			<el-link v-if="!base_url" type="primary" :href="`http://law.foodmate.net/show-163478.html`" target="_blank">《农业转基因生物安全管理条例》</el-link>
			的有关规定进行安全评价，获得农业转基因生物安全证书后，再按照
			<el-link v-if="base_url" type="primary" :href="base_url + '7284'" target="_blank">《新饲料和新饲料添加剂管理办法》</el-link>
			<el-link v-if="!base_url" type="primary" :href="`http://law.foodmate.net/show-174810.html`" target="_blank">《新饲料和新饲料添加剂管理办法》</el-link>
			的有关规定进行评审。
          </p>
          <p>3.宠物饲料生产企业采购、使用农业农村部第21公告增补的78种饲料添加剂时，市场上暂无饲料级产品的，可采购、使用食品级或者医药级产品暂时替代。自2019年5月1日起，宠物饲料生产企业使用的饲料添加剂均应当具有相应的饲料许可证明文件。</p>
          <h2>四、新饲料和新饲料添加剂有关事宜公告</h2>
          <p>新饲料和新饲料添加剂的监测期为5年，自新饲料、新饲料添加剂证书核发之日起计算。监测期内的新饲料添加剂品种仅允许所列申请单位或其授权的单位生产。</p>
          <h2>五、饲料添加剂安全使用规范</h2>
          <p>1、各省、自治区、直辖市人民政府饲料管理部门实施饲料添加剂（混合型饲料添加剂除外）生产许可应遵守本《规范》规定，不得核发含量规格低于本《规范》或者生产工艺与本《规范》不一致的饲料添加剂生产许可证明文件。</p>
          <p>2、饲料企业和养殖者使用饲料添加剂产品时，应严格遵守“在配合饲料或全混合日粮中的最高限量”规定，不得超量使用饲料添加剂；在实现满足动物营养需要、改善饲料品质等预期目标的前提下，应采取积极措施减少饲料添加剂的用量。</p>
          <p>3、饲料企业和养殖者使用《饲料添加剂品种目录》中铁、铜、锌、锰、碘、钴、硒、铬等微量元素饲料添加剂时，含同种元素的饲料添加剂使用总量应遵守本《规范》中相应元素“在配合饲料或全混合日粮中的最高限量”规定。</p>
          <p>4、仔猪（≤25 kg）配合饲料中锌元素的最高限量为110 mg/kg，但在仔猪断奶后前两周特定阶段，允许在此基础上使用氧化锌或碱式氯化锌至1600 mg/kg（以锌元素计）。饲料企业生产仔猪断奶后前两周特定阶段配合饲料产品时，如在含锌110 mg/kg基础上使用氧化锌或碱式氯化锌，应在标签显著位置标明“本品仅限仔猪断奶后前两周使用”，未标明但实际含量超过110 mg/kg或者已标明但实际含量超过1600 mg/kg的，按照超量使用饲料添加剂处理。</p>
          <p>5、饲料企业和养殖者使用非蛋白氮类饲料添加剂，除应遵守本《规范》对单一品种的最高限量规定外，全混合日粮中所有非蛋白氮总量折算成粗蛋白当量不得超过日粮粗蛋白总量的30%。</p>
          <p>6、如无特殊说明，本《规范》“在配合饲料或全混合日粮中的推荐添加量”“在配合饲料或全混合日粮中的最高限量”均以干物质含量88%为基础计算，最高限量均包含饲料原料本底值。</p>
          <p>7、如无特殊说明，添加剂预混合饲料、浓缩饲料、精料补充料产品中的“推荐添加量”“最高限量”按其在配合饲料或全混合日粮中的使用比例折算。</p>
  </div>
</template>

<script>
import header from '@/components/header'

export default {
  name: 'index',
  data() {
    return {
		base_url:''
    };
  },
  components: {
    'v-header':header
  },
  created() {
  	this.toLaiyuan()
  },
  methods: {
    toLaiyuan(){
      var host = decodeURIComponent(this.getCookie('syy_domain'))
      var host2 = this.getCookie('quanxian')
      if(host && host2 == 20){
        var cookie_value = this.getCookie('tjj')
        var base_url = ''
        if (cookie_value == 1){
          base_url = host+"/home/biaofa.biaofa_list/faguicontent?quanku=1&itemid="
        }else {
          base_url = host+"/home/biaofa.fagui/content?quanku=1&itemid="
        }
        this.base_url = base_url
        console.log('base_url:', base_url)
      }
    },
    getCookie(cookie_name) {
      // var allcookies = document.cookie;
      // //索引长度，开始索引的位置
      // var cookie_pos = allcookies.indexOf(cookie_name);
      // // 如果找到了索引，就代表cookie存在,否则不存在
      // if (cookie_pos != -1) {
      // 	// 把cookie_pos放在值的开始，只要给值加1即可
      // 	//计算取cookie值得开始索引，加的1为“=”
      // 	cookie_pos = cookie_pos + cookie_name.length + 1;
      // 	//计算取cookie值得结束索引
      // 	var cookie_end = allcookies.indexOf(";", cookie_pos);
      // 	if (cookie_end == -1) {
      // 		cookie_end = allcookies.length;
      // 	}
      // 	//得到想要的cookie的值
      // 	var value = unescape(allcookies.substring(cookie_pos, cookie_end));
      // }
      // return value;

      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${cookie_name}=`);
      if (parts.length === 2) {
        return parts[1].split(';')[0].trim(); // 取第二个元素，分割后取第一个值并去空格
      }
      return null; // 未找到
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index{
  padding-bottom: 40px;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
h2,p{
  text-align: left;
}
h2{
  background: #f6f6f6;
}
p{
  text-indent: 2em;
font-size: 14px;
line-height: 2;
color: rgba(51, 51, 51, 0.85);
}
p /deep/ .el-link--inner{
  text-indent: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue